import { CertifikatFiltrDto, IdentifikaceOsobyFiltrDto, OpravneniFiltrDto, PageAndSortDto } from '@generated/be';
import { TableLazyLoadEvent } from '@openng/optimus-ui/table';
import { Table } from '@openng/optimus-ui/table';
import { SortMeta } from '@openng/optimus-ui/api';

export const getBasicSinglePageQueryParam = (evt: TableLazyLoadEvent, sorting: string): PageAndSortDto => {
  return {
    sortPage: sorting,
    start: evt.first,
    count: evt.rows || undefined,
  };
};

export function clearWrongOsobaValues(
  filtr: OpravneniFiltrDto | CertifikatFiltrDto,
  zastupujiciFO = false,
  zastupovanaFO = false,
  certifikaty = false,
  majitelFO = false
) {
  if (certifikaty) {
    clearCertifikatFiltrValues(filtr as CertifikatFiltrDto, majitelFO);
  } else {
    clearOpravneniFiltrValues(filtr as OpravneniFiltrDto, zastupujiciFO, zastupovanaFO);
  }
}

function clearCertifikatFiltrValues(filtr: CertifikatFiltrDto, majitelFO: boolean) {
  if (!filtr.majitel) return;

  if (majitelFO) {
    clearOrganizationValues(filtr.majitel);
  } else {
    clearPersonValues(filtr.majitel);
  }
}

function clearOpravneniFiltrValues(filtr: OpravneniFiltrDto, zastupujiciFO: boolean, zastupovanaFO: boolean) {
  if (filtr.zastupujiciOsoba) {
    if (zastupujiciFO) {
      clearOrganizationValues(filtr.zastupujiciOsoba);
    } else {
      clearPersonValues(filtr.zastupujiciOsoba);
    }
  }

  if (filtr.zastupovanaOsoba) {
    if (zastupovanaFO) {
      clearOrganizationValues(filtr.zastupovanaOsoba);
    } else {
      clearPersonValues(filtr.zastupovanaOsoba);
    }
  }
}

function clearPersonValues(person: IdentifikaceOsobyFiltrDto) {
  person.datumNarozeni = undefined;
  person.dokladTotoznosti = undefined;
  person.jmeno = undefined;
  person.prijmeni = undefined;
}

function clearOrganizationValues(organization: IdentifikaceOsobyFiltrDto) {
  organization.ico = undefined;
}

export function getVolitelnostTooltips(option: SelectTooltipOption): SelectTooltipOption {
  switch (option.id) {
    case 'PRI_POSTOUPENI':
      option.tooltip =
        'Pokud je vybraná položka "Volitelná při postoupení", uživatel může při postoupení na třetí osobu odebrat danou skupinu.';
      break;
    case 'PRI_SESTAVENI':
      option.tooltip =
        'Pokud je vybraná položka "Volitelná při sestavování", uživatel si při sestavování oprávnění sám může zvolit, ' +
        'zda tato skupina omezení má být součástí sestavovaného oprávnění k zastupování.';
      break;
    case 'PRI_SESTAVENI_A_POSTOUPENI':
      option.tooltip =
        'Pokud je vybraná položka "Volitelná při sestavování a postoupení", uživatel si při sestavování oprávnění sám může zvolit, zda tato' +
        ' skupina omezení má být součástí sestavovaného oprávnění k zastupování a při postoupení na třetí osobu může danou skupinu odebrat.';
      break;
  }
  return option;
}

/**
 * Helps to keep consistency between our API which takes "id" or "-id" for sorting and p-table which takes object with order "1" or "-1".
 * @param sortBy - usually variable SORTING_TYPE_DEFAULT
 * @returns object suitable for p-table
 */
export const prepareTableSorting = (
  sortBy: string
): {
  field: Table['sortField'];
  order: Table['sortOrder'];
} => {
  const firstChar = sortBy.substring(0, 1);

  if (firstChar === '-') {
    return {
      field: sortBy.substring(1),
      order: -1,
    };
  } else {
    return {
      field: sortBy,
      order: 1,
    };
  }
};

/**
 * Converts a list of sort strings (e.g. ['-createdAt', 'name'])
 * into an array of PrimeNG SortMeta objects.
 */
export const prepareTableSortingList = (sortByList: string[]): SortMeta[] => {
  if (!Array.isArray(sortByList)) return [];

  return sortByList.map((sortBy) => {
    const firstChar = sortBy.substring(0, 1);
    return {
      field: firstChar === '-' ? sortBy.substring(1) : sortBy,
      order: firstChar === '-' ? -1 : 1,
    };
  });
};

interface SelectTooltipOption {
  id: unknown;
  label: string;
  tooltip?: string;
}

export const capitalizeWords = (value: string | null | undefined): string => {
  if (!value) return '';
  return value
    .toLowerCase()
    .split(/([\s-]+)/)
    .map((part) => (part && !/^[\s-]+$/.test(part) ? part.charAt(0).toUpperCase() + part.slice(1) : part))
    .join('');
};
